import { useEffect } from "react";

const DEFAULT_TITLE = "BharatiCrafts — Online Shopping Store";

const setMeta = (name, content) => {
  let el = document.querySelector(`meta[name="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute("name", name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const useSeo = ({ title, description, jsonLd }) => {
  useEffect(() => {
    if (!title) return;
    const prevDesc = document.querySelector('meta[name="description"]')?.getAttribute("content") || "";
    document.title = title;
    if (description) setMeta("description", description);
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seo = "page";
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta("description", prevDesc);
      script?.remove();
    };
  }, [title, description, JSON.stringify(jsonLd)]); // eslint-disable-line
};
